import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'
import CartItem from '../CartItem'
import kebabCase from 'lodash/kebabCase'
import { Icon } from '@saatva-bits/pattern-library.components.icon'
import { useExperiment } from '@saatva-bits/pattern-library.modules.launch-darkly'
import { deliveryTypes } from '@/config/globals'
import ShipmentDeliveryInfoModal from '@/components/Shipments/ShipmentDeliveryInfoModal'
import { getShipmentDeliveryEstimate } from '@/utils/order'
import classNames from 'classnames'

const Shipments = ({ items = [], sitewidePromo, setIsExtendModalVisible }) => {
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [selectedShipment, setSelectedShipment] = useState({})
    const { isV1: SHOW_DELIVERY_ESTIMATES } = useExperiment('EXP.SHOW_DELIVERY_ESTIMATES.CONV-339')

    const shipments = useMemo(() => {
        return [
            {
                title: 'White Glove Delivery',
                type: 'whiteGlove',
                items: items.filter((item) => item.deliveryType === deliveryTypes.whiteGlove)
            },
            {
                title: 'Ground Delivery',
                type: 'direct',
                items: items.filter((item) => item.deliveryType === deliveryTypes.direct)
            }
        ].filter((shipment) => !!shipment.items.length)
    }, [items])


    const handleOpenDeliveryInfoModalOnClick = (shipment) => {
        setSelectedShipment(shipment)
        setIsModalVisible(true)
    }
    const handleCloseDeliveryInfoModalOnClick = () => {
        setIsModalVisible(false)
    }

    if (!shipments.length) {
        return null
    }

    return (
        <>
            <li className={styles.container}>
                {shipments.map((shipment) => (
                    <div key={kebabCase(shipment.title)} className={styles.shipment}>
                        <div className={classNames(styles.shipmentHeader, { hasMargin: !SHOW_DELIVERY_ESTIMATES })}>
                            <h4 className={styles.title}>{shipment.title}</h4>
                            <button
                                type='button'
                                alt='delivery type info button'
                                className={styles.deliveryInfoModalButton}
                                data-selector={`cart-delivery-info-modal-${shipment.type}`}
                                onClick={() => handleOpenDeliveryInfoModalOnClick(shipment)}
                            >
                                <Icon
                                    name='circleTooltip'
                                    className={styles.deliveryInfoModalIcon}
                                    alt="delivery type info icon"
                                    description="delivery-info-icon"
                                    width="16"
                                    height="16"
                                    titleId="delivery-info-icon"
                                />
                            </button>
                        </div>

                        {SHOW_DELIVERY_ESTIMATES && (
                            <p className={styles.estimatedDelivery}>{getShipmentDeliveryEstimate(shipment)}</p>
                        )}

                        <ul className={styles.productList}>
                            {shipment.items?.map((item) => (
                                <li key={`cart-item-${item.id}`}>
                                    <CartItem
                                        item={item}
                                        sitewidePromo={sitewidePromo}
                                        setIsExtendModalVisible={setIsExtendModalVisible}
                                    />
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
                <ShipmentDeliveryInfoModal
                    shipment={selectedShipment}
                    isModalVisible={isModalVisible}
                    handleCloseDeliveryInfoModalOnClick={handleCloseDeliveryInfoModalOnClick}
                />
            </li>
        </>
    )
}

Shipments.propTypes = {
    items: PropTypes.array,
    sitewidePromo: PropTypes.any,
    setIsExtendModalVisible: PropTypes.func.isRequired
}

export default Shipments
